// extracted by mini-css-extract-plugin
module.exports = {"total-row":"TotalRow_total-row__WFDr2","edit-pricing":"TotalRow_edit-pricing__2JBja","total-cell":"TotalRow_total-cell__30ZXp"};